import React from "react";

const DesignItem = ({ active, onClick, label, iconClasses }) => (
  <div className={`design-list-item ${active ? "active" : ""}`} onClick={onClick}>
    <span className={`${iconClasses} design-list-icon`} />
    <span className="design-list-item-label">{label}</span>
  </div>
);

export default DesignItem;
